import { render, staticRenderFns } from "./AuthLogDetailCard.vue?vue&type=template&id=1606e870&"
import script from "./AuthLogDetailCard.vue?vue&type=script&lang=js&"
export * from "./AuthLogDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports